export const gamePaymentTypeOptions =[
    {text:"Free",value:"1296b786-c6de-45f9-8363-552112605904"},
    {text:"Payed",value:"88f7193d-72e5-4ddd-aff6-1f9b25ab0a56"}
]

export const createGamePaymentTypeOptions = (t: any) => [
    { text: t('gamePaymentTypes.free'), value: "1296b786-c6de-45f9-8363-552112605904" },
    { text: t('gamePaymentTypes.payed'), value: "88f7193d-72e5-4ddd-aff6-1f9b25ab0a56" }
];